import { all } from 'redux-saga/effects';

import roleSaga from './role-saga';

export default function* rootSaga() {
  yield all([roleSaga()]);
}
